import { PRIMARY_PROPERTY_FIELDS } from "../components/PropertyMappingSelector/PropertyMappingSelector.constants";

/** Check if a field name is a primary field */
export function isPrimaryField(fieldName: string): boolean {
	return PRIMARY_PROPERTY_FIELDS.has(fieldName as any);
}

/** Check if an errors object has at least one primary field error */
export function hasPrimaryFieldErrors(errors: Record<string, string>): boolean {
	return Object.keys(errors).some(isPrimaryField);
}

/** Filter errors to only primary field errors */
export function filterToPrimaryFieldErrors(errors: Record<string, string>): Record<string, string> {
	const result: Record<string, string> = {};
	for (const [key, msg] of Object.entries(errors)) {
		if (isPrimaryField(key)) result[key] = msg;
	}
	return result;
}
